export default {
  // 员工列表页
  queryStaffList: '/auth/user/pageList', // 获取员工列表 
  querydeptAndOrg: '/auth/token/condition/deptAndOrg', // 获取组织部门数据
  queryFundOwner: '/auth/token/condition/orgAndSchool', // 查询款项归属

  // 员工新增、编辑页
  queryInfoByUId: '/auth/user/query', // 根据工号查询个人信息
  queryVirtualId: '/auth/user/queryCode',  // 根据员工类型获取 虚拟员工id
  addStaff: '/auth/user/create', // 新增员工接口
  changeStaffStatus: '/auth/user/userValidity', // 切换员工二次入职和离职
  deleteUser: '/auth/user/deleteUser', // 根据钉钉号删除用户
  orgInfoUpdate: '/auth/user/infoUpdate', // 新增员工-编辑部门组织
  refreshPassword: '/auth/user/refreshPassword', // 编辑员工 重置密码
  sendDingTalk: '/auth/user/modifyUserInfoSendDingTalk'
}


// WEBPACK FOOTER //
// ./src/api/staff.js